import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSummer = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2a.75.75 0 0 1 .75.75V4.6a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 12 2M4.995 4.995a.75.75 0 0 1 1.06 0l1.308 1.308a.75.75 0 0 1-1.06 1.06L4.995 6.055a.75.75 0 0 1 0-1.06m14.142 0a.75.75 0 0 1 0 1.06L17.83 7.363a.75.75 0 0 1-1.06-1.06l1.308-1.308a.75.75 0 0 1 1.06 0M12 8.125a3.875 3.875 0 1 0 0 7.75 3.875 3.875 0 0 0 0-7.75M6.625 12a5.375 5.375 0 1 1 10.75 0 5.375 5.375 0 0 1-10.75 0M2 12a.75.75 0 0 1 .75-.75H4.6a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 12m16.65 0a.75.75 0 0 1 .75-.75h1.85a.75.75 0 0 1 0 1.5H19.4a.75.75 0 0 1-.75-.75M7.364 16.768a.75.75 0 0 1 0 1.06l-1.308 1.309a.75.75 0 1 1-1.06-1.06l1.307-1.309a.75.75 0 0 1 1.06 0m9.404 0a.75.75 0 0 1 1.06 0l1.309 1.308a.75.75 0 0 1-1.06 1.06l-1.309-1.307a.75.75 0 0 1 0-1.061M12 18.65a.75.75 0 0 1 .75.75v1.85a.75.75 0 0 1-1.5 0V19.4a.75.75 0 0 1 .75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSummer;
